import React from "react"
import SbEditable from "storyblok-react"

import Components from "../components"
import Footer from "../components/footer"
import MetaData from "../components/meta-data"
import Navigation from "../components/navigation"
import getSectionsAnchors from "../helpers/handleSectionAnchors"

import { pageBlokType, globalDataType } from "../types"

interface LandingLayoutV2Props {
  globalData: globalDataType
  blok: pageBlokType
  path: string
}

const LandingLayoutV2: React.FC<LandingLayoutV2Props> = ({
  globalData,
  blok,
  path,
}) => (
  <>
    <SbEditable content={blok}>
      {blok.meta_data &&
        blok.meta_data.map((md) => (
          <MetaData key={md._uid} meta_data={md} path={path} />
        ))}
      <div className="page-landing-v2">
        {blok.header &&
          blok.header.map((content) => {
            if (content.component === "navigation") {
              return (
                <Navigation
                  key={content._uid}
                  anchorList={getSectionsAnchors(blok.body)}
                />
              )
            }
            return (
              React.createElement(Components(content.component), {
                key: content._uid,
                blok: content,
              })
            )
          })}
        {blok.body &&
          blok.body.map(
            (content) =>
              React.createElement(Components(content.component), {
                key: content._uid,
                blok: content,
              })
          )}
      </div>
    </SbEditable>
    {globalData.footer &&
      globalData.footer.map((footer) => (
        <Footer key={footer._uid} blok={footer} landingFooter={true} />
      ))}
  </>
)

export default LandingLayoutV2
